import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { getAccessToken } from "../../storage/storage";
import { FiCalendar, FiCheckSquare, FiEdit, FiHome, FiMail, FiUsers, FiSettings, FiUser } from "react-icons/fi";
import { MdOutlineSpaceDashboard, MdOutlineAddHome } from "react-icons/md";
import { TbUsersPlus } from "react-icons/tb";
import { GoOrganization } from "react-icons/go";

const Sidebar = ({ isOpen, onClose }) => {
  const token = getAccessToken();
  const location = useLocation();

  const menuItems = [
    { 
      name: "Dashboard", 
      path: "/dashboard", 
      icon: <MdOutlineSpaceDashboard />,
      badge: null
    },
    {
      name: "Upcoming Stays",
      path: "/stays",
      icon: <FiCalendar />,
      badge: null
    },
    {
      name: "Ad Hoc Tasks",
      path: "/other-tasks",
      icon: <FiCheckSquare />,
      badge: null
    },
    {
      name: "My Properties",
      path: "/settings/properties",
      icon: <FiHome />,
      badge: null,
      tab: "Properties"
    },
    {
      name: "My Cleaners",
      path: "/settings/cleaners",
      icon: <GoOrganization />,
      badge: null,
      tab: "Cleaners"
    },
    {
      name: "My Invitations",
      path: "/send-invitation",
      icon: <FiMail />,
      badge: null
    },
    { type: "divider" },
    {
      name: "Add Properties",
      path: "/property",
      icon: <MdOutlineAddHome />,
      badge: null
    },
    {
      name: "Invite Cleaners",
      path: "/invite-cleaner",
      icon: <TbUsersPlus />,
      badge: null
    },
    { type: "divider" },
    {
      name: "Manage Cleaner Tasks",
      path: "/task",
      icon: <FiEdit />,
      badge: null
    },
    {
      name: "My Profile",
      path: "/settings/profile",
      icon: <FiUser />,
      badge: null,
      tab: "Profile"
    },
    {
      name: "My Companies",
      path: "/settings/company",
      icon: <GoOrganization />,
      badge: null,
      tab: "Company"
    },
    { type: "divider" },
     {
      name: "Settings",
      path: "/settings/profile",
      icon: <FiSettings />,
      tab: "Profile"
    },
  ];

  const isOtherTasksActive =
    location.pathname.startsWith("/other-tasks") ||
    location.pathname.startsWith("/other-tasksheets/") ||
    location.pathname.startsWith("/task-invoice/");

  return (
    <div className="w-55 h-full flex flex-col border-r border-gray-200 shadow-lg bg-white overflow-hidden">
      {/* Logo Section */}
      <div className="p-6 border-b border-gray-200 flex-shrink-0">
        <div className="flex items-center space-x-2">
          <img
            src="/images/main-logo.jpg"
            alt="HouseKeeper Logo"
            className="h-10 w-auto"
          />
          <div>
            <h1 className="text-lg font-bold text-[#586989]">HouseKeeper</h1>
            <p className="text-xs text-gray-500">Property Management</p>
          </div>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="flex-1 px-4 py-2 space-y-1 overflow-y-auto">
        {menuItems.map((item, index) => {
          if (item.type === "divider") {
            return (
              <div key={`divider-${index}`} className="border-t border-gray-200 my-2"></div>
            );
          }

          const isActive = 
            location.pathname === item.path ||
            (item.path === "/other-tasks" && isOtherTasksActive) ||
            (item.path.startsWith("/settings") && location.pathname.startsWith("/settings") && location.pathname === item.path);

          return (
            <NavLink
              key={item.path}
              to={{
                pathname: item.path
              }}
              onClick={() => {
                if (item.path === "/property") {
                  sessionStorage.removeItem("edit");
                }
                if (item.tab) {
                  // Store the active tab in sessionStorage for the Settings page to read
                  sessionStorage.setItem("settingsActiveTab", item.tab);
                }
                if (onClose) onClose();
              }}
              className={`
                flex items-center space-x-3 px-3 py-3 rounded-lg transition-all duration-200
                ${isActive
                  ? "bg-[#FFF5CE] text-[#586989] font-semibold"
                  : "text-gray-600 hover:bg-gray-100 hover:text-[#586989]"
                }
              `}
            >
              <span className="text-xl">{item.icon}</span>
              <span className="flex-1 text-sm font-medium">{item.name}</span>
              {item.badge && (
                <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                  {item.badge}
                </span>
              )}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};

export default Sidebar;